<template>
  <article
    class="search-result-list-item-parts"
    :class="markClass(product.created, product.modified)"
  >
    <a :href="`/lineup/${type}/detail/?id=${product.product_id}`">
      <figure class="search-result-list-item-parts__figure">
        <img
          v-if="product.images[0]"
          :src="product.images[0]"
          alt=""
          class="search-result-list-item-parts__image"
        >
      </figure>
      <div class="search-result-list-item-parts__details">
        <ul
          v-if="(markHtml(product.created, product.modified) + markHtmlUnused(type, product, conditions)) !== ''"
          class="search-result-list-item-parts__icons"
          v-html="markHtml(product.created, product.modified) + markHtmlUnused(type, product, conditions)"
        />
        <header class="search-result-list-item-parts__header">
          <h3 v-text="productName" />
          <p
            v-if="product.color"
            v-text="product.color"
          />
        </header>

        <div class="search-result-list-item-parts__shop-meta">
          <p
            class="search-result-list-item-parts__shop-name"
            v-if="product.shop_id !== 0"
            v-text="shop_name"
          />
          <p
            class="search-result-list-item-parts__reference-number"
            v-if="product.reference_number"
            v-text="product.reference_number"
          />
        </div>

        <div class="search-result-list-item-parts__performance">
          <dl class="displacement" v-if="product.displacement">
            <dt>排気量</dt>
            <dd v-text="`${product.displacement.toLocaleString()}CC`"/>
          </dl>
          <dl class="displacement" v-if="product.model_year && type === 'new'">
            <dt>モデルイヤー</dt>
            <dd v-text="`${product.model_year}`"/>
          </dl>
          <dl class="displacement" v-if="product.manufacturer && type === 'new'">
            <dt>製造国名</dt>
            <dd v-text="`${product.manufacturer}`"/>
          </dl>

          <dl class="displacement" v-if="conditions.mileage && isUsed(type)">
            <dt>走行距離</dt><dd v-text="`${Number(conditions.mileage).toLocaleString()}km`" />
          </dl>

          <dl class="displacement" v-else-if="isUsed(type)">
            <dt>走行距離</dt><dd>0km</dd>
          </dl>

          <dl class="displacement" v-if="conditions.register_year && isUsed(type)">
            <dt>初年度登録(届出)年</dt>
            <dd v-text="conditions.register_year" />
          </dl>

          <dl class="evaluation" v-if="rate && isUsed(type)">
            <dt>総合評価</dt><dd v-text="rate" />
          </dl>
        </div>
        <dl class="search-result-list-item-parts__price" v-if="product.price">
          <dt>現金販売価格（消費税込）</dt>
          <dd class="price_num" v-text="`${product.price.toLocaleString()}円`" />
          <dd class="price_notax" v-text="`（消費税抜本体価格 ￥${Math.ceil(product.price / TAX).toLocaleString()})`" />
        </dl>

        <ul
          v-if="bannerArray.length > 0"
          class="search-result-list-item-parts__campaign"
        >
          <li
            v-for="(banner, i) in bannerArray"
            :key="`banner${i}`"
            v-html="banner"
            class="search-result-list-item-parts__campaign-item"
          />
        </ul>
      </div>
    </a>
  </article>
</template>

<script>
import {defineComponent, computed} from 'vue'
import {Util} from '../../../master.js'
import dayjs from 'dayjs'

export default defineComponent({
  name: 'SearchResultItemParts',
  components: {},
  props: {
    item: {
      type: Object,
      default: () => {},
      required: true,
    },
    type: {
      type: String,
      default: 'new',
    },
    banner: {
      type: Array,
      default: () => []
    },
  },
  setup(props) {
    const { TAX, NEW_ARRIVAL_PERIOD } = Util
    const product = computed(() => props.item)
    const conditions = computed(() => props.item.product_condition || {})

    const shop_name = computed(() => {
      let rt = ''
      Util.DEALER.area.forEach(area => {
        area.shops.forEach(shop => {
          if (shop.id === props.item.shop_id) {
            rt = shop.name
          }
        })
      })
      return rt
    })

    /**
     * 総合評価の星を返却
     * @param rate Number
     */
    const getRateStar = (rate) => {
      const temp = Number(rate)
      let rt = ''
      for (let i = 0; i < temp; i += 1) {
        rt += '★'
      }
      return rt
    }

    const rate = computed(() => {
      if (!props.item.product_condition) {
        return ''
      }
      return getRateStar(props.item.product_condition.rating_total)
    })

    /**
     * 3日前のデータを dayjs で取得する
     * format は YYYY-MM-DD で取得する
     */
    const diffDate = dayjs().subtract(NEW_ARRIVAL_PERIOD, 'day').unix()

    /**
     * 新着表示判定
     * @param created
     * @param modified
     */
    const markClass = (created, modified) => {
      const createdUnix = dayjs(created).unix()
      const modifiedUnix = dayjs(modified).unix()
      if (createdUnix > diffDate) {
        return 'new_prod'
      } else if (modifiedUnix > diffDate) {
        return 'upd_prod'
      }
      return ''
    }

    /**
     * タグを返却する
     * @param created
     * @param modified
     */
    const markHtml= (created, modified) => {
      const createdUnix = dayjs(created).unix()
      const modifiedUnix = dayjs(modified).unix()
      if (createdUnix > diffDate) {
        return '<li class="new">新着</li>'
      } else if (modifiedUnix > diffDate) {
        return `<li class="update">更新</li>`
      }
      return ''
    }

    const productName = computed(() => {
      if (props.item.product_name) {
        return props.item.product_name.replace(/[！-～]/g, (s) => {
          // prettier-ignore
          return String.fromCharCode(s.charCodeAt(0) - 0xFEE0)
        }).replace(/　/g,' ')
      } else {
        return ''
      }
    })

    const markHtmlUnused = (type, product, conditions) => {
      const unused = product.unused_force;
      const mileage = conditions.mileage;
      const displacement = product.displacement;

      if (type !== 'used' && type !== 'unused') {
        return '';
      }
      if (unused || (Number(mileage) <= 3 && Number(displacement) > 125)) {
        return '<li class="unused">登録済み未使用車</li>'
      }
      return ''
    }

    const isUsed = (type) => {
      return type === 'used' || type === 'unused';
    }

    const bannerArray = computed(() => {
      const banner = props.banner.banners
      let result = []
      if (banner == undefined || banner.length == 0) return result

      banner.forEach(banner => {
        if (banner.target.includes(props.type)) {
          const dom = banner.content

          if (banner.title === props.item.product_name) {
            result.push(dom)
          } else {
            banner.displacement.forEach(displacement => {
              const displacementRange = (displacement).split(':')

              if (
                product.value.displacement >= displacementRange[0] && product.value.displacement <= displacementRange[1]
              ) {
                result.push(dom)
              }
            })
          }
        }
      })

      return result
    })

    return {
      TAX,
      product,
      conditions,
      shop_name,
      markClass,
      markHtml,
      rate,
      productName,
      markHtmlUnused,
      isUsed,
      bannerArray
    }
  },
})

</script>